export default __webpack_public_path__ + "static/media/Tickler of the Autumn Night.3a4216e5.jpg";